import Vue from 'vue';
import {
	Form,
	Field,
	Button,
	Popup,
	Picker,
	Uploader,
	Cell,
	CellGroup,
	Checkbox,
	RadioGroup,
	Radio,
	CheckboxGroup,
	Toast,
	Pagination,
	Dialog,
	Tabs,
	Tab
} from 'vant';

Toast.setDefaultOptions({ duration: 3000 });

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Uploader);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(CheckboxGroup);
Vue.use(Toast);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(Tab);